var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.plugins.length > 0
    ? _c(
        "div",
        { staticClass: "plugins" },
        [
          _c(
            "el-row",
            _vm._l(_vm.plugins, function (plugin) {
              return _c("el-col", { key: plugin.id, staticClass: "plugin" }, [
                _c(
                  "div",
                  { staticClass: "inner" },
                  [
                    plugin.enabled
                      ? [
                          _c("a", { staticClass: "enabled" }, [
                            _c("img", {
                              class: plugin.plugin_type,
                              attrs: { src: _vm.getPluginImage(plugin) },
                            }),
                            _c("div", [
                              _c("p", { staticClass: "contract-label" }, [
                                _c("span", { staticClass: "title" }, [
                                  _vm._v(_vm._s(_vm.$t("UserInfo.contracted"))),
                                ]),
                              ]),
                            ]),
                          ]),
                        ]
                      : [
                          _c(
                            "a",
                            {
                              staticClass: "disabled",
                              on: {
                                click: function ($event) {
                                  return _vm.showPluginDialog(plugin)
                                },
                              },
                            },
                            [
                              _c("img", {
                                class: plugin.plugin_type,
                                attrs: { src: _vm.getPluginImage(plugin) },
                              }),
                              _c("p", { staticClass: "uncontract-label" }, [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$t("UserInfo.uncontracted"))
                                  ),
                                ]),
                              ]),
                            ]
                          ),
                        ],
                  ],
                  2
                ),
              ])
            }),
            1
          ),
          _c(
            "el-dialog",
            {
              staticClass: "plugin enabledPlugins",
              attrs: {
                title: _vm.selectedPlugin.title,
                visible: _vm.isShowEnabledPluginDialog,
                width: "600px",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.isShowEnabledPluginDialog = $event
                },
              },
            },
            [
              _c("div", { staticClass: "plugin-image" }, [
                _c("img", { attrs: { src: _vm.selectedPlugin.image } }),
              ]),
              _c("p", {
                domProps: { innerHTML: _vm._s(_vm.selectedPlugin.description) },
              }),
              _c("p", [
                _vm._v(
                  _vm._s(
                    _vm.$t("Plugin.confirm_adding", {
                      plugin: _vm.selectedPlugin.name,
                    })
                  )
                ),
              ]),
              _c("p", { staticClass: "plugin-price" }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("UserInfo.plugins.price_type")) + "："),
                ]),
                _c("span", {
                  domProps: { innerHTML: _vm._s(_vm.selectedPlugin.price) },
                }),
              ]),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { disabled: _vm.isLoading },
                      on: {
                        click: function ($event) {
                          _vm.isShowEnabledPluginDialog = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("UserInfo.cancelButton")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        loading: _vm.isLoading,
                        disabled: _vm.isLoading,
                      },
                      on: { click: _vm.enablePlugin },
                    },
                    [_vm._v(_vm._s(_vm.$t("UserInfo.contract")))]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }